import axios from 'axios';
import swal from "sweetalert";
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';

export function signUp(email, password) {
    //axios call
    const postData = {
        email,
        password,
        returnSecureToken: true,
    };
    return axios.post(
        `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
        postData,
    );
}

// export function login(email, password) {
//     const postData = {
//         email,
//         password,
//         returnSecureToken: true,
//     };
//     return axios.post(
//         `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
//         postData,
//     );
// }

export function login(UserName, Password , captcha) {
    const postData = {
        UserName,
        Password,
        captcha: captcha,
    };
    return axios.post(
        `https://core.pskeromais.com.br/api/v1/login`,
        postData,
        {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
        },
    );
}

export function sendToReCapatcha(token) {
    const postData = {
        token
    }
    return axios.post(
        `https://core.pskeromais.com.br/api/v1/verify`,
        postData,
        {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
        },
    );
}

export function formatError(errorResponse) {
    if (!errorResponse) {
        return 'Erro de conexão com o servidor';
    }

    switch (errorResponse.error?.message) {
        case 'EMAIL_EXISTS':
            return 'Email já existe';
        case 'EMAIL_NOT_FOUND':
            return 'Email não encontrado';
        case 'INVALID_PASSWORD':
            return 'Senha inválida';
        case 'USER_DISABLED':
            return 'Usuário desativado';
        default:
            return errorResponse.message || 'Erro ao realizar operação';
    }
}

export function saveTokenInLocalStorage(tokenDetails, name) {
    if (!tokenDetails || !tokenDetails.data) {
        console.error('Dados do token inválidos');
        return false;
    }

    try {
        tokenDetails.expireDate = new Date(
            new Date().getTime() + 3600 * 1000,
        );
        tokenDetails.idToken = tokenDetails.data;
        tokenDetails.expiresIn = "3600";
        tokenDetails.refreshToken = tokenDetails.data;
        tokenDetails.registered = true;
        tokenDetails.name = name;
        localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
        return true;
    } catch (error) {
        console.error('Erro ao salvar token:', error);
        return false;
    }
}

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        //dispatch(Logout(history));
        dispatch(Logout(navigate));
    }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        dispatch(Logout(navigate));
		return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();

    if (todaysDate > expireDate) {
        dispatch(Logout(navigate));
        return;
    }
		
    dispatch(loginConfirmedAction(tokenDetails));
	
    const timer = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, timer, navigate);
}
